// 产品对比
import { http_get } from './helpers';
import { version } from './config';
import { Properties, Models } from './types';

// 获取参数
export const getProperties = http_get<
    {
        productIds: string;
    },
    Properties[]
>(`/api/v${version}/m/Comparison/Properties`);

// 获取模型
export const getModels = http_get<
    {
        productIds: string;
    },
    Models[]
>(`/api/v${version}/m/Comparison/Models`);

// 获取图纸
export const getDrawings = http_get<
    {
        productIds: string;
    },
    Models[]
>(`/api/v${version}/m/Comparison/Drawings`);
